<template>
<div class="divider">
    <p class="contentLabel">{{ $t('Add.General.Alignment') }}</p>
    <div class="input-container">
    <label>
        <input type="radio" class="radios" name="alignment" value="left" v-model="alignment" />
        <span class="radioSelect firstSelect"><span class="material-symbols-outlined firstSelect">format_align_left</span></span>
    </label>
    <label>
        <input type="radio" class="radios" name="alignment" value="center" v-model="alignment" />
        <span class="radioSelect"><span class="material-symbols-outlined">format_align_center</span></span>
    </label>
    <label class="last">
        <input type="radio" class="radios" name="alignment" value="right" v-model="alignment" />
        <span class="radioSelect lastSelect"><span class="material-symbols-outlined align">format_align_right</span></span>
    </label>
    </div>
</div>
</template>

<script>
export default {
    props: ['sharedData'],
    computed:{
    alignment: {
      get() {
        return this.sharedData?.data?.style?.textAlign || 'left';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.textAlign = value;
      },
    },
    }

}
</script>

<style>
@import '../../../styles/addComponents.css';
</style>